import '../vendor/masonry.pkgd';
import throttle from '../vendor/lodash-es/throttle';

const grids = document.querySelectorAll( '.js-grid' );
const throttleTime = 150;

[ ...grids ].forEach( ( grid ) => {
  const msnry = new window.Masonry( grid, {
    percentPosition: true,
  } );

  window.addEventListener( 'resize', resize );

  function resize() {
    throttle( () => msnry.layout(), throttleTime, { leading: false } );
  }
} );
